import React from 'react';
import { Helmet } from 'react-helmet-async';
import { DEFAULT_DOMAIN, MetaConfig, MetaInput, resolveMeta } from 'seo/metaBuilders';

export { stripHtmlTags } from 'seo/text';

export type SEOProps = MetaInput;

// Environment config for the shared meta builders (seo/metaBuilders)
export const seoConfig: MetaConfig = {
  domain: process.env.REACT_APP_PUBLIC_DOMAIN || DEFAULT_DOMAIN,
  userApiBase: process.env.REACT_APP_BASE_API || '',
  postApiBase: process.env.REACT_APP_BASE_API_POST || ''
};

export const SEO: React.FC<SEOProps> = (props) => {
  const meta = resolveMeta(
    props,
    typeof window !== 'undefined' ? window.location.href : seoConfig.domain
  );
  const canonicalUrl = meta.canonical;

  return (
    <Helmet>
      {/* Standard Meta Tags */}
      <title>{meta.title}</title>
      <meta name="description" content={meta.description} />
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}

      {/* Robots indexing tag */}
      <meta name="robots" content={meta.robots} />

      {/* Open Graph Tags */}
      <meta property="og:site_name" content="4um" />
      <meta property="og:title" content={meta.ogTitle} />
      <meta property="og:description" content={meta.ogDescription} />
      <meta property="og:type" content={meta.ogType} />
      {canonicalUrl && <meta property="og:url" content={canonicalUrl} />}
      {meta.ogImage && <meta property="og:image" content={meta.ogImage} />}

      {/* Twitter Cards */}
      <meta name="twitter:card" content={meta.twitterCard} />
      <meta name="twitter:title" content={meta.ogTitle} />
      <meta name="twitter:description" content={meta.ogDescription} />
      {meta.ogImage && <meta name="twitter:image" content={meta.ogImage} />}

      {/* Structured Data (JSON-LD) */}
      {meta.jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(meta.jsonLd)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
